import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';

import { Form, Input, Button, Modal, Select, InputNumber } from 'antd';
const FormItem = Form.Item;

class LocationForwardForm extends Component {

    state = {
        modalVisible: false,
        confirmDirty: false,
        coreParkingLocationId: null,
    }

    form = null;

    componentWillReceiveProps(nextProps) {
        this.setState({
            modalVisible: nextProps.modalVisible
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                try {
                    if (values.forwardConfig) values.forwardConfig = JSON.parse(values.forwardConfig);
                    if (values.forwardData) values.forwardData = JSON.parse(values.forwardData);
                } catch (parseErr) {
                    return;
                }
                this.props.onSuccess(this.props.form, values);
            }
        });
    }

    handleConfirmBlur = e => {
        const { value } = e.target;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    };

    renderForm() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const driverType = getFieldValue('driverType');
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };

        return (
            <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
                <FormItem
                    {...formItemLayout}
                    label="Lokalita" >
                    {getFieldDecorator('corelocationId', {
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <ParkinglocationSelect />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Popis">
                    {getFieldDecorator('description', {
                    })(
                        <Input.TextArea autosize={{ minRows: 2, maxRows: 4 }} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Událost" >
                    {getFieldDecorator('eventListener', {
                        rules: [{
                            type: 'string', message: 'Položka musí být string!',
                        }, {
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }
                        ],
                    })(
                        <Input />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="ForwardConfig">
                    {getFieldDecorator('forwardConfig', {
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }, {
                            validator: (rule, value, callback) => {
                                if (!value) return callback();
                                let parsed;
                                try { parsed = JSON.parse(value); } catch (e) { return callback('Hodnota musí být platný JSON!'); }
                                if (typeof parsed !== 'object' || Array.isArray(parsed)) return callback('ForwardConfig musí být JSON objekt!');
                                const allowed = new Set(['method', 'url', 'headers', 'queryParams']);
                                const unknown = Object.keys(parsed).filter(k => !allowed.has(k));
                                if (unknown.length) return callback(`Nepovolené vlastnosti: ${unknown.join(', ')}`);
                                if (!parsed.method) return callback('forwardConfig.method nesmí být prázdné!');
                                if (!['GET', 'POST', 'PUT'].includes(parsed.method)) return callback('forwardConfig.method musí být GET, POST nebo PUT!');
                                if (!parsed.url || typeof parsed.url !== 'string') return callback('forwardConfig.url musí být neprázdný string!');
                                callback();
                            }
                        }],
                    })(
                        <Input.TextArea autosize={{ minRows: 2, maxRows: 4 }} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="ForwardData">
                    {getFieldDecorator('forwardData', {
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }, {
                            validator: (rule, value, callback) => {
                                if (!value) return callback();
                                let parsed;
                                try { parsed = JSON.parse(value); } catch (e) { return callback('Hodnota musí být platný JSON!'); }
                                if (typeof parsed !== 'object' || Array.isArray(parsed)) return callback('ForwardData musí být JSON objekt!');
                                callback();
                            }
                        }],
                    })(
                        <Input.TextArea autosize={{ minRows: 2, maxRows: 4 }} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Čas odeslání"
                    extra="Prázdné = odeslat ihned při změně">
                    {getFieldDecorator('scheduledForwardTime', {
                        rules: [{
                            type: 'string', message: 'Položka musí být string!',
                        }, {
                            pattern: /^([01]\d|2[0-3]):[0-5]\d$/, message: 'Formát musí být HH:MM!',
                        }],
                    })(
                        <Input placeholder="HH:MM" />
                    )}
                </FormItem>

                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit">Vložit</Button>
                </FormItem>
            </Form>
        );
    }

    render() {
        if (this.props.type && this.props.type === 'modal') {
            return (
                <Modal
                    width={650}
                    title="Vytvoření nové lokality"
                    visible={this.state.modalVisible}
                    onCancel={() => {
                        this.props.onModalCancel(this.props.form);
                        this.setState({ modalVisible: false });
                    }}
                    footer={<p></p>}>
                    {this.renderForm()}
                </Modal>
            )
        } else {
            return this.renderForm();
        }
    }
}

const WrappedLocationForwardForm = Form.create()(LocationForwardForm);

export default WrappedLocationForwardForm;


// WEBPACK FOOTER //
// ./src/components/LocationForwardForm.js